import type { Specialist } from "@/lib/types"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
// @ts-ignore
import React from "react"

interface EmployeeHeaderProps {
  specialist: Specialist
}

export function EmployeeHeader({ specialist }: EmployeeHeaderProps) {
  return (
    <div className="flex-1 min-w-0 p-2 md:p-4 flex flex-col items-center text-center min-h-[56px] md:min-h-[80px] gap-1">
      <Avatar className="h-8 w-8 mb-1 md:h-10 md:w-10 shrink-0">
        <AvatarImage src={specialist.avatar || "/public/placeholder-user.jpg"} alt={specialist.name || "Unknown"} />
        <AvatarFallback>{specialist.name?.[0] || "?"}</AvatarFallback>
      </Avatar>
      <div className="font-medium text-xs md:text-sm truncate leading-tight min-w-0">{specialist.name || "Unknown"}</div>
      {/* Mobile & Desktop: wrap up to 2 lines, break long words */}
      <div className="text-[11px] md:text-xs text-muted-foreground whitespace-normal break-words leading-snug line-clamp-2">
        {specialist.role || "No role specified"}
      </div>
    </div>
  )
}
